module.exports = __webpack_public_path__ + "img/2-10.c2d22f9a.png";